import { BannerExtension, TcfModuleContext } from "./extension";
import { loadScript } from "./prefs-loader";

/**
 * Loads bc-tcf.js from where bc.js came from and starts it. Sites without the TCF never download it.
 * Resolves to null when it cannot load: the banner then works without the TCF.
 */
export async function loadTcfModule(
  win: Window,
  doc: Document,
  scriptUrl: string | null,
  context: TcfModuleContext,
): Promise<BannerExtension | null> {
  if (
    !win.__berrycookieTcf &&
    !(await loadScript(doc, scriptUrl, "bc-tcf.js"))
  ) {
    console.warn(
      "[BerryCookie] bc-tcf.js could not be loaded; the TCF is off.",
    );
    return null;
  }
  return win.__berrycookieTcf
    ? win.__berrycookieTcf.create(context).catch(() => null)
    : null;
}
